import React from 'react'
import ReactDOM from 'react-dom'
import ProductGroupSelectionPageContainer from '../containers/ProductGroupSelectionPageContainer';
import ContactDetailsPageContainer from '../containers/ContactDetailsPageContainer';
import VisibleOfferRequestSentPage from '../containers/VisibleOfferRequestSentPage';
import PanelSelectionPageContainer from '../containers/PanelSelectionPageContainer';
import StoveAndLigthingSelectionPageContainer from '../containers/StoveAndLigthingSelectionPageContainer';
import LigthSelectionPageContainer from '../containers/ligthSelectionPageContainer';
import GlassWallSelectionPage from '../containers/GlassWallSelectionPageContainer';
import FeedbackPageContainer from '../containers/FeedbackPageContainer';
import BenchMaterialSelectionPageContainer from '../containers/BenchMaterialSelectionPageContainer';
import Slider from 'react-slick';
import SaunaMeasurementsContainer from '../containers/SaunaMeasurementsContainer';
import SelectDoorAndStovePostitionContainer from '../containers/SelectDoorAndStovePostitionContainer';
import InstallProductPageContainer from '../containers/InstallProductPageContainer';
import SelectBenchShapePageContainer from '../containers/SelectBenchShapePageContainer'
import VisibleSliderHeader from '../containers/VisibleSliderHeader';
import SliderTabsContainer from '../containers/SliderTabsContainer';
import PlanSummaryPageContainer from '../containers/PlanSummaryPageContainer'
import DownloadAttachmentsPageContainer from '../containers/DownloadAttachmentsPageContainer'
import SelectBenchModelPageContainer from '../containers/SelectBenchModelPageContainer'
import AskPlanTypeContainer from '../containers/AskPlanTypeContaner'


import { ElementQueries, ResizeSensor } from 'css-element-queries';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import localization from '../helpers/localization.js';





var settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: false,
    swipe: false,
    draggable: false,
    adaptiveHeight: true,
    dots: false
};
ElementQueries.listen();
class mainSliderComponent extends React.Component {
    slideConfigurations = [];
    constructor(props) {
        super();
        this.pages = {
            askPlanTypeContainer:
            {
                component: <AskPlanTypeContainer nextPage={() => this.nextSlide()} />,
                header: "Tarjouksen tyyppi",
                showTab: false,
                materialImageShown:false
            },
            productGroupSelection:
            {
                component: <ProductGroupSelectionPageContainer prevPage={() => this.prevSlide()} nextPage={() => { if (this.hasAtleastOneProduct()) this.nextSlide(); else { this.showAlert(localization.chooseAtLeastOneProduct) } }} />,
                header: localization.chooseProducts,
                showTab: false,
                materialImageShown: false
            },
            chooseModelPage:
            {
                component: <SelectBenchModelPageContainer nextPage={() => this.nextSlide()} prevPage={() => this.prevSlide()}></SelectBenchModelPageContainer>,
                header: localization.chooseBenchModel,
                showTab: true,
                showHandler: (products, ui) => products.includes("bench"),
                materialImageShown: true
            },
            chooseShapePage:
            {
                component: <SelectBenchShapePageContainer nextPage={() => this.nextSlide()} prevPage={() => this.prevSlide()} />,
                header: localization.chooseBenchShape,
                showTab: true,
                showHandler: (products, ui) => products.includes("bench"),
                materialImageShown: true
            },
            choosePanelMaterial:
            {
                component: <PanelSelectionPageContainer nextPage={() => this.nextSlide()} prevPage={() => this.prevSlide()} />,
                header: localization.panelMaterialSelection,
                showTab: true,
                showHandler: (products, ui) => products.includes("paneling"),
                materialImageShown: true
            },
            chooseBenchMaterial:
            {
                component: <BenchMaterialSelectionPageContainer nextPage={() => this.nextSlide()} prevPage={() => this.prevSlide()} />,
                header: localization.benchMaterialSelection,
                showTab: true,
                showHandler: (products, ui) => products.includes("bench"),
                materialImageShown: true
            },
            chooseLights:
            {
                component: <LigthSelectionPageContainer nextPage={() => this.nextSlide()} prevPage={() => this.prevSlide()} />,
                header: localization.lightSelection,
                showTab: true,
                showHandler: (products, ui) => products.includes("lights"),
                materialImageShown: true
            },
            chooseStove:
            {
                component: <StoveAndLigthingSelectionPageContainer nextPage={() => this.nextSlide()} prevPage={() => this.prevSlide()} />,
                header: localization.stoveAndLigthSelection,
                showTab: true,
                showHandler: (products, ui) => products.includes("stove"),
                materialImageShown: true
            },
            giveSaunaMeasurements:
            {
                component: <SaunaMeasurementsContainer prevPage={() => this.prevSlide()} nextPage={() => this.nextSlide()} gotoContactDetails={() => this.gotoContactDetails()} />,
                header: localization.giveSaunaMeasurements,
                showTab: true,
                showHandler: (products, ui) => products.includes("bench") || products.includes("paneling") || products.includes("door")
            },
            selectInstallProduct:
            {
                component: <InstallProductPageContainer prevPage={() => this.prevSlide()} nextPage={() => this.nextSlide()} />,
                header: localization.install,
                showTab: true,
                materialImageShown: true
            },
            positioning:
            {
                component: <SelectDoorAndStovePostitionContainer nextPage={() => this.nextSlide()} prevPage={() => this.prevSlide()} />,
                header: localization.positioningForDoorAndStove,
                showTab: true,
                showHandler: (products, ui) => products.includes("bench") && !ui.positioningSkipped
            },
            selectGlassWall: {
                component: <GlassWallSelectionPage nextPage={() => this.nextSlide()} prevPage={() => this.prevSlide()} />,
                header: localization.doorPageHeader,
                showTab: true,
                showHandler: (products, ui) => products.includes("door")
            },
            uploadCadImages: {
                component: <DownloadAttachmentsPageContainer nextPage={() => this.nextSlide()} prevPage={() => this.prevSlide()} />,
                header: "Kuvien lataus",
                showTab: true,
                onshown: this.updateCadDownloaImage
            },
            contactDetails: {
                component: <ContactDetailsPageContainer nextPage={() => this.nextSlide()} prevPage={() => this.prevSlide()} />,
                header: localization.finishPlan,
                showTab: true,
                hideNextButton: true,
                materialImageShown:true
            },
            offerRequestSent: {
                component: <VisibleOfferRequestSentPage gotoStart={() => this.gotoStart()} />,
                header: localization.thankYou,
                showTab: false,
                hideArrows: true
            },
            planSummary: {
                component: <PlanSummaryPageContainer nextPage={() => this.nextSlide()} prevPage={() => this.prevSlide()} />,
                header: localization.finishPlan,
                showTab: true,
                materialImageShown:true
            },
            postOfferFeedback: {

                component: <FeedbackPageContainer gotoStart={() => this.gotoStart()} />,
                header: localization.thankYou,
                showTab: false,
                hidenextbutton: true
            }
        };
        this.slideConfigurations["default"] = [
            this.pages.askPlanTypeContainer,
            this.pages.productGroupSelection,
            this.pages.chooseModelPage,
            this.pages.giveSaunaMeasurements,
            this.pages.chooseShapePage,
            this.pages.positioning,
            this.pages.chooseBenchMaterial,
            this.pages.choosePanelMaterial,
            this.pages.chooseLights,
            this.pages.chooseStove,
            this.pages.selectGlassWall,
            this.pages.selectInstallProduct,
            this.pages.contactDetails,
            this.pages.postOfferFeedback
        ];
        this.slideConfigurations["onlyAskBasicDetails"] = [
            this.pages.askPlanTypeContainer,
            this.pages.contactDetails,
            this.pages.postOfferFeedback
        ]

        this.slideConfigurations["talotehdas"] = [
            this.pages.chooseModelPage,      
            this.pages.choosePanelMaterial,
            this.pages.chooseBenchMaterial,
            this.pages.chooseLights,
            this.pages.chooseStove,
            this.pages.giveSaunaMeasurements,
            this.pages.chooseShapePage,
            this.pages.positioning,
            this.pages.selectGlassWall,
            this.pages.uploadCadImages,
            this.pages.contactDetails,
            this.pages.offerRequestSent
        ];
        this.slideConfigurations["jukkatalo"] =
            [
                this.pages.choosePanelMaterial,
                this.pages.chooseStove,
                this.pages.chooseModelPage,
                this.pages.chooseShapePage,
                this.pages.chooseBenchMaterial,
                this.pages.chooseLights,
                this.pages.positioning,
                this.pages.planSummary,
                this.pages.offerRequestSent
            ];
        this.slideConfigurations["rakka-asunnot"] = [
            this.pages.chooseStove,
            this.pages.chooseModelPage,
            this.pages.chooseShapePage,
            this.pages.chooseBenchMaterial,
            this.pages.chooseLights,
            this.pages.positioning,
            this.pages.planSummary,
            this.pages.offerRequestSent
        ];
        this.slideConfigurations["swingclean"] = [
            this.pages.chooseShapePage,
            this.pages.chooseBenchMaterial,
            this.pages.choosePanelMaterial,
            this.pages.chooseLights,
            this.pages.giveSaunaMeasurements,
            this.pages.positioning,
            this.pages.contactDetails,
            this.pages.offerRequestSent
        ];

        this.onShownHandlers = [];
    }
    render() {
        this.ui = { positioningSkipped: this.props.positioningSkipped }
        let component = {};
        if (this.props.displayError === false) {
            let slideConfig = this.buildSlideConfig(this.props.slideConfiguration, this.props.products);
            let slides = this.buildSlides(slideConfig);
            component =
                (<div>
                    <SliderTabsContainer tabs={slideConfig} onTabClick={(e) => this.gotoSlide(e)}></SliderTabsContainer>
                    {<VisibleSliderHeader onNextSlideClick={() => this.nextSlide()} onPrevSlideClick={() => this.prevSlide()}>
                    </VisibleSliderHeader>}
                    <Row><Col sm={12}>
                        {slides}
                    </Col></Row></div>);
        }
        else {
            component = (<h1>{this.props.errorMessage}</h1>);
        }
       /* else {
            component = (<h1>{localization.planSentPreviously}</h1>);
        }*/
        return component;
    }
    nextSlide() {
        this.mainSlider.slickNext();
    }
    prevSlide() {
        if (this.mainSlider.innerSlider.state.currentSlide !== 7 || this.props.measurementsSkipped === false) {
            this.mainSlider.slickPrev();
        }
        else {
            this.mainSlider.slickGoTo(5);
        }
    }
    gotoStart() {
        this.mainSlider.slickGoTo(0);
    }
    gotoSlide(slideIndex) {
        this.mainSlider.slickGoTo(slideIndex);
    }
    gotoContactDetails() {
        this.mainSlider.slickGoTo(7);
    }
    updateCadDownloaImage() {
        let canvas = document.querySelector(".konvajs-content canvas");
        let cadimage = canvas.toDataURL("image/jpeg");
        document.querySelector("#caddownnloadimage").src = cadimage;
        document.querySelector("#caddownloadbutton").href = cadimage;
    }
    beforeChange(current, next) {
        if (this.mainSlider) {
            this.adaptHeight();
            let slider = this.mainSlider;
            let list = ReactDOM.findDOMNode(slider.innerSlider.list);
            let selector = '[data-mainsliderindex="' + next + '"]';
            let header = list.querySelector(selector);     
            let showPrevButton = next > 0 && !header.dataset.hidearrows && !Boolean(header.dataset.hideprevbutton);
            let showNextButton = next < this.mainSlider.props.children.length - 1 && !header.dataset.hidearrows && !Boolean(header.dataset.hidenextbutton)
            if (this.onShownHandlers[next]) this.onShownHandlers[next]();
            this.props.pageChanged(next, header.dataset.header, showPrevButton, showNextButton, header.dataset.materialimageshown == "true" ? true : false);
            new ResizeSensor(header, () => this.adaptHeight());
        }
    }
    adaptHeight(sender) {
        if (this.mainSlider) {
            let slider = this.mainSlider;
            let list = ReactDOM.findDOMNode(slider.innerSlider.list);
            let selector = '[data-mainsliderindex="' + slider.innerSlider.state.currentSlide + '"]';
            let e = list.querySelector(selector);
            if (e) list.style.height = e.offsetHeight + 'px';
        }
    }
    componentDidMount() {
        if (this.mainSlider) {
            this.beforeChange(0,0);
            let slider = this.mainSlider;
            slider.innerSlider.adaptHeight = () => { this.adaptHeight() };
        }
    }

    showAlert(message) {
        this.props.showAlert(message);
    }

    buildSlides(slideConfiguration) {
        this.onShownHandlers = [];
        return <Slider {...settings} beforeChange={(current, next) => this.beforeChange(current,next)}  ref={(slider) => { this.mainSlider = slider; }}>
            {slideConfiguration.map((slide, index) => {

                if (slide.onshown) {
                    this.onShownHandlers[index] = slide.onshown;
                }
                return (<div data-mainsliderindex={index} data-materialimageshown={slide.materialImageShown} data-header={slide.header} data-hidearrows={slide.hideArrows} data-hideprevbutton={slide.hidePrevButton} data-hidenextbutton={slide.hideNextButton} key={index}>
                    {slide.component}
                </div >);
            })}

        </Slider>;
    }

    buildSlideConfig(slideConfiguration, products) {
        let slides = this.slideConfigurations[slideConfiguration].filter(s => !s.showHandler || s.showHandler(products, this.props.ui));

        return slides;
    }
    filterSlideByProducts(slideProducts, planProducts) {
        if (slideProducts) {
            return planProducts.filter(p => slideProducts.includes(p)).length > 0;
        }
        else return true;
    }

    hasAtleastOneProduct() {
        return this.props.products.length > 0;

    }
}
export default mainSliderComponent


